module.exports = __webpack_public_path__ + "img/pr-14.c9056bf1.png";